<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.cooling.step1.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.product"
          :label="$t('technicalFile.closedLoop.step2.product')"
          :items="products"
          class="text-field-transparent"
          itemValue="id"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.injectionMethod"
          :label="$t('technicalFile.closedLoop.step2.injection')"
          :items="displayedUnits('injectionMethod')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.pumpModel"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step2.pumpModel')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.maxPressure.value"
          class="text-field-transparent"
          :label="$t('technicalFile.closedLoop.step2.maxPressure')"
          type="number"
          min="0"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.maxPressure.units"
          :label="$t('technicalFile.closedLoop.step2.unit')"
          :items="displayedUnits('pressure')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.operation"
          :label="$t('technicalFile.closedLoop.step2.operation')"
          :items="displayedUnits('treatmentOperation')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Treatment',
    components: {
        VTextField,
    },
    props: {
        treatment: {
            type: Object,
            default: () => {},
        },
        siteId: {
            type: String,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                maxPressure: {
                    value: null,
                    units: null,
                },
            },
            products: [],
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },

    watch: {
        treatment: {
            handler() {
                if (this.treatment) {
                    this.data = { ...this.data, ...cloneDeep(this.treatment) };
                }
            },
            immediate: true,
        },
    },
    async created() {
        await this.loadProducts({ initialLoad: true, type: 'initial' });
    },
    methods: {
        async loadProducts() {
            if (this.siteId) {
                const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined({ selectAll: true }, true);
                const { data } = await this.$rq.getSiteProducts(this.siteId, cleanQueryParams);
                this.products = data.products;
            }
        },
        updateData() {
            this.$emit('sendData', { treatment: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
